function InputSection({ centimeters, inches }) {
    return (
        <div className="w-[180px] shrink-0 flex items-center border-b border-r border-[#EAEAEA]">
            <div className="w-1/2 px-4 py-3 border-r border-[#EAEAEA]">
                <p className={`${centimeters ? '' : 'text-[#A0A0A0]'} w-full outline-none placeholder:text-center text-center`}>
                    {centimeters ? centimeters : 'cm'}
                </p>
            </div>

            <div className="w-1/2 px-6 py-3">
                <p className={`${inches ? '' : 'text-[#A0A0A0]'} w-full outline-none placeholder:text-center text-center`}>
                    {inches ? inches : 'in'}
                </p>
            </div>
        </div>
    )
}

export default InputSection;
